export const GET_MESSAGE = "GET_MESSAGE";
export const GET_CAMPAIGN = "GET_CAMPAIGN";